import { useId } from 'react'
import CtaLink, { CtaLinkProps } from './cta-link'
import HubspotCTA, { HubspotCTAProps } from './hubspot-cta'

type CtaLink = {
  id: string
  __typename?: 'CtaLink'
  label?: string
} & CtaLinkProps

type CtaLinkWithTypename = Partial<Omit<Queries.ContentfulComponentCtaLink, 'link' | 'style'>> & {
  __typename: 'ContentfulComponentCtaLink'
  link?: Partial<Queries.ContentfulComponentCtaLink['link']> | null
} & CtaLinkProps

type HubspotCtaWithTypename = Omit<Queries.ContentfulComponentHubspotCta, 'style'> & {
  __typename: 'ContentfulComponentHubspotCta'
} & HubspotCTAProps

export type DynamicActionProps = CtaLink | CtaLinkWithTypename | HubspotCtaWithTypename

/** Renders the correct CTA component based on the typename */
export default function DynamicAction({ label, ...props }: DynamicActionProps): JSX.Element {
  const uid = useId()
  props.id = uid + props.id

  switch (props.__typename) {
    case 'ContentfulComponentHubspotCta':
      // eslint-disable-next-line no-case-declarations, @typescript-eslint/no-unused-vars
      const { __typename: hubspotTypename, ...hubspotCtaProps } = props
      return <HubspotCTA {...hubspotCtaProps}>{label}</HubspotCTA>
    case 'ContentfulComponentCtaLink':
      // eslint-disable-next-line no-case-declarations, @typescript-eslint/no-unused-vars
      const { link, __typename: contentfulCtaLinkTypename, ...contentfulCtaLinkProps } = props
      return (
        link?.url && (
          <CtaLink to={link?.url} {...contentfulCtaLinkProps}>
            {label}
          </CtaLink>
        )
      )
    case 'CtaLink':
      // eslint-disable-next-line no-case-declarations, @typescript-eslint/no-unused-vars
      const { __typename: ctaLinkTypename, ...ctaLinkProps } = props
      return <CtaLink {...ctaLinkProps}>{label || props.children}</CtaLink>
    default:
      return null
  }
}
